const SONIC_ENTITLEMENT_CODES = new Set([
  "PIVONY_SONIC_ENTITLEMENT_REQUIRED",
]);

const isSonicSubscriptionMessage = (message) => {
  const text = String(message || "").toLowerCase();
  return (
    text.includes("pivony sonic subscription") ||
    text.includes("pivony sonic aboneliği")
  );
};

/** Map Sonic API error payloads to user-facing copy. */
export function resolveSonicApiError(res, t, fallbackKey = "sonic.api_error_generic") {
  if (!res || res.cancel) {
    return t(fallbackKey);
  }

  const code = res.error_code || res.code;
  if (code && SONIC_ENTITLEMENT_CODES.has(code)) {
    return t("sonic.subscription_required");
  }

  const message = typeof res.error === "string" ? res.error.trim() : "";
  if (message) {
    if (isSonicSubscriptionMessage(message)) {
      return t("sonic.subscription_required");
    }
    if (/api key is not configured/i.test(message)) {
      return t("sonic.elevenlabs_api_key_error");
    }
    return message;
  }

  return t(fallbackKey);
}

export function isSonicSubscriptionError(res) {
  if (!res) return false;
  const code = res.error_code || res.code;
  if (code && SONIC_ENTITLEMENT_CODES.has(code)) return true;
  return isSonicSubscriptionMessage(res.error);
}
